﻿import type { ServerSideBlotterSearchRequest } from 'apiConnector/blotters';
import { DlpProductsGrid } from 'components/Blotters/Trades/Grid/dlp-products-grid';
import { ProductsBlotterServerSideGrid } from 'components/Blotters/Trades/Grid/products-blotter-server-side-grid';
import { TradesBlotterServerSideGrid } from 'components/Blotters/Trades/Grid/trades-blotter-server-side-grid';
import { useAppSelector } from 'hooks/useAppSelector';
import type { Dispatch, SetStateAction } from 'react';
import { selectTradesBlottersType } from 'state/blotters/trades/tradesBlotters.selector';

interface GridByTypeProps {
  setLastBlotterRequest: Dispatch<SetStateAction<ServerSideBlotterSearchRequest | undefined>>;
}

export function GridByType({ setLastBlotterRequest }: GridByTypeProps) {
  const type = useAppSelector(selectTradesBlottersType);

  switch (type) {
    case 'dlpProducts':
      return <DlpProductsGrid />;
    case 'trades':
      return <TradesBlotterServerSideGrid setLastBlotterRequest={setLastBlotterRequest} />;
    case 'products':
      return <ProductsBlotterServerSideGrid setLastBlotterRequest={setLastBlotterRequest} />;
  }
}
